import { getAgente, getAgentes } from "../services/agentes.services";
import { useGeneralAppStore } from "../store/generalAppStore";

const { handlerModal } = useGeneralAppStore.getState();

export const handlerGetAgentes = async (setAgentes) => {
  const resp = await getAgentes();
  if (resp) {
    setAgentes(resp);
    console.log(resp);
  }
};

export const handlerUnAgente = async (payload, set) => {
  const resp = await getAgente(payload);
  if (resp) {
    set(resp?.interacciones_un_agente);
    if (payload?.nivel == "mes") {
      handlerModal({ modal: true, modalName: "interacciones_dia" });
    }
  }
};

export const handlerDiasAgenteSelect = async (payload, setInteraccionesCadaDia) => {
  const resp = await getAgente(payload);
  if (resp) {
    console.log(resp);
    setInteraccionesCadaDia(resp?.interacciones_un_agente);
  }
};
